import { defineMessages } from 'react-intl';
import { addSchemaField } from '@redturtle/iovisit-theme/config';

const messages = defineMessages({
  show_full_width: {
    id: 'show_full_width',
    defaultMessage: 'A tutta larghezza',
  },
  size: {
    id: 'size',
    defaultMessage: 'Dimensione',
  },
  slidesToShow: {
    id: 'slidesToShow',
    defaultMessage: 'N° slide da mostrare',
  },
  square_images: { id: 'square_images', defaultMessage: 'Immagini quadrate' },
  text_bg_color: {
    id: 'text_bg_color',
    defaultMessage: 'Colore di sfondo del testo',
  },
  show_item_title: {
    id: 'show_item_title',
    defaultMessage: "Mostra il titolo dell'elemento",
  },
  show_icon: {
    id: 'show_icon',
    defaultMessage: "Mostra l'icona dell'elemento",
  },
  show_thematic_area: {
    id: 'show_thematic_area',
    defaultMessage: "Mostra l'area tematica",
  },
  show_item_description: {
    id: 'show_item_description',
    defaultMessage: "Mostra la descrizione dell'elemento",
  },
  show_detail_link: {
    id: 'show_detail_link',
    defaultMessage: 'Mostra il link al dettaglio',
  },
  detail_link_text: {
    id: 'detail_link_text',
    defaultMessage: 'Testo del link al dettaglio',
  },
  show_detail_link_arrow: {
    id: 'show_detail_link_arrow',
    defaultMessage: 'Mostra la freccia nel link al dettaglio',
  },
  show_dots: {
    id: 'show_dots',
    defaultMessage: 'Mostra i puntini di scorrimento',
  },
  autoplay: {
    id: 'autoplay',
    defaultMessage: 'Autoplay',
  },
  autoplay_speed: {
    id: 'autoplay_speed',
    defaultMessage: 'Velocità autoplay',
  },
  autoplay_speed_description: {
    id: 'autoplay_speed_description',
    defaultMessage: 'La velocità di autoplay deve essere espressa in secondi.',
  },
  primary: {
    id: 'primary',
    defaultMessage: 'Primario',
  },
  secondary: {
    id: 'secondary',
    defaultMessage: 'Secondario',
  },
  tertiary: {
    id: 'tertiary',
    defaultMessage: 'Terziario',
  },
  white: {
    id: 'white',
    defaultMessage: 'Bianco',
  },
});

const getSliderVariationSchema = (schema, formData, intl, pos = 0) => {
  // only show field if no bg has been set
  // bg already sets full-width
  if (!formData.show_block_bg) {
    addSchemaField(
      schema,
      'full_width',
      intl.formatMessage(messages.show_full_width),
      null,
      { type: 'boolean' },
      pos,
    );

    pos++;
  }

  addSchemaField(
    schema,
    'size',
    intl.formatMessage(messages.size),
    null,
    { type: 'size' },
    pos,
  );
  pos++;

  addSchemaField(
    schema,
    'square_images',
    intl.formatMessage(messages.square_images),
    null,
    { type: 'boolean', default: false },
    pos,
  );
  pos++;

  addSchemaField(
    schema,
    'text_bg_color',
    intl.formatMessage(messages.text_bg_color),
    null,
    {
      widget: 'color_list',
      colors: [
        { name: 'primary', label: intl.formatMessage(messages.primary) },
        { name: 'secondary', label: intl.formatMessage(messages.secondary) },
        { name: 'tertiary', label: intl.formatMessage(messages.tertiary) },
        { name: 'white', label: intl.formatMessage(messages.white) },
      ],
      defaultValue: 'white',
    },
    pos,
  );
  pos++;

  addSchemaField(
    schema,
    'show_item_title',
    intl.formatMessage(messages.show_item_title),
    null,
    { type: 'boolean', default: true },
    pos,
  );
  pos++;

  addSchemaField(
    schema,
    'show_icon',
    intl.formatMessage(messages.show_icon),
    null,
    { type: 'boolean', default: false },
    pos,
  );
  pos++;

  addSchemaField(
    schema,
    'show_thematic_area',
    intl.formatMessage(messages.show_thematic_area),
    null,
    { type: 'boolean', default: true },
    pos,
  );
  pos++;

  addSchemaField(
    schema,
    'show_item_description',
    intl.formatMessage(messages.show_item_description),
    null,
    { type: 'boolean', default: false },
    pos,
  );
  pos++;

  addSchemaField(
    schema,
    'show_detail_link',
    intl.formatMessage(messages.show_detail_link),
    null,
    { type: 'boolean', default: true },
    pos,
  );
  pos++;

  addSchemaField(
    schema,
    'detail_link_text',
    intl.formatMessage(messages.detail_link_text),
    null,
    {},
    pos,
  );
  pos++;

  addSchemaField(
    schema,
    'show_detail_link_arrow',
    intl.formatMessage(messages.show_detail_link_arrow),
    null,
    { type: 'boolean', default: false },
    pos,
  );
  pos++;

  addSchemaField(
    schema,
    'show_dots',
    intl.formatMessage(messages.show_dots),
    null,
    { type: 'boolean', default: true },
    pos,
  );
  pos++;

  addSchemaField(
    schema,
    'autoplay',
    intl.formatMessage(messages.autoplay),
    null,
    { type: 'boolean', default: false },
    pos,
  );
  pos++;

  addSchemaField(
    schema,
    'autoplay_speed',
    intl.formatMessage(messages.autoplay_speed),
    intl.formatMessage(messages.autoplay_speed_description),
    { type: 'number', default: 2 },
    pos,
  );
  pos++;

  pos = addSchemaField(
    schema,
    'slidesToShow',
    intl.formatMessage(messages.slidesToShow),
    null,
    { type: 'number', default: 1 },
    pos,
  );
  return pos;
};

export default getSliderVariationSchema;
